export interface TimeDesignationInterface {
  id: number;
  time: string;
}

export const timeDesignations = [
  { id: 1, time: "最短日時で届けてほしい" },
  { id: 2, time: "午前中に届けてほしい" },
  { id: 3, time: "14～16時に届けてほしい" },
  { id: 4, time: "16～18時に届けてほしい" },
  { id: 5, time: "18～20時に届けてほしい" },
  { id: 6, time: "19～21時に届けてほしい" }
] as TimeDesignationInterface[];
